import NextImage from "next/image"
import { twMerge } from "tailwind-merge"

export interface ImageProps {
  url: string
  width: number
  height: number
  alt?: string
  priority?: boolean
  className?: string
  blurDataURL?: string
}

const Image: React.FC<ImageProps> = ({ url, width, height, alt, className, priority, blurDataURL }) => {
  return (
    <NextImage
      className={twMerge("object-contain", className)}
      src={url}
      width={width}
      height={height}
      alt={alt ?? ""}
      priority={priority}
      blurDataURL={blurDataURL}
      placeholder={blurDataURL ? "blur" : "empty"}
    />
  )
}
export default Image
